import PreguntaService from 'src/modules/pregunta/preguntaService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'PREGUNTA_VIEW';

const preguntaViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: preguntaViewActions.FIND_STARTED,
      });

      const record = await PreguntaService.find(id);

      dispatch({
        type: preguntaViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: preguntaViewActions.FIND_ERROR,
      });

      getHistory().push('/pregunta');
    }
  },
};

export default preguntaViewActions;
